<script>
  import { onMount } from 'svelte';
  import { reparse_date } from '../../../lib/utils.js';
  import TextField from '../../../lib/components/TextField.svelte';
  import { MDCDialog } from '@material/dialog';
  import APIClient from '../../../state-charts/api-client';
  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import session from '../../../lib/session.js';
  import moment from 'moment';

  // component options  ------------------------------------------------------ //

  export let order;
  export let role;
  export let comment;
  export let name;
  export let img;
  export let has_inited;
  export let order_uuid;

  let short_comment = null;
  let edit_dialog;

  const get_rating_icon = rating => {
    if (rating === 'sad') return 'sentiment_very_dissatisfied';
    if (rating === 'neutral') return 'sentiment_dissatisfied';
    if (rating === 'happy') return 'sentiment_satisfied_alt';
    if (rating === 'extremely_happy') return 'sentiment_very_satisfied';
  };

  let complete_ratings = [
    { name: 'sad', is_active: true },
    { name: 'neutral', is_active: false },
    { name: 'happy', is_active: false },
    { name: 'extremely_happy', is_active: false },
  ];

  const init_comment = () => {
    for (let i = 0; i < complete_ratings.length; i++) {
      complete_ratings[i].is_active =
        complete_ratings[i].name === comment.rating;
    }

    let element = document.getElementById(`edit-dialog-` + role);
    if(!!element) edit_dialog = new MDCDialog(element);
    short_comment = comment.message;
  };

  const get_active_rating = () => {
    for (let i = 0; i < complete_ratings.length; i++) {
      if (complete_ratings[i].is_active) {
        return complete_ratings[i].name;
      }
    }
  };

  const edit_comment = async () => {
    if ($session.user.last_role === 'orderer') {
      await APIClient.update_worker_feedback(
        {
          comment: short_comment,
          order_uuid: order_uuid,
          rating: get_active_rating(),
        },
        () => {
          location.reload();
        }
      );
    } else {
      await APIClient.update_orderer_feedback(
        {
          comment: short_comment,
          order_uuid: order_uuid,
          rating: get_active_rating(),
        },
        () => {
          location.reload();
        }
      );
    }
  };

  const rating_set_active = index => {
    for (let i = 0; i < complete_ratings.length; i++) {
      complete_ratings[i].is_active = i === index;
    }
  };

  const close = () => {
    edit_dialog.close();
  };

  const open = () => {
    edit_dialog.open();
  };

  onMount(init_comment);
</script>

<article class="row {`comment-item ${role}`}">
  <div class="column-comment">
    <div class="comment-message">
      <div id="container" class="comment-message-header">
        <img src={img} class="comment-avatar" />
        <span style="vertical-align: middle" class="name-text">{name}</span>
        <div class="rating-block">
          <i class="material-icons">{get_rating_icon(comment.rating)}</i>
        </div>

      </div>
      <div class="comment-message-content">
        <div class="comment-date">
          {reparse_date(moment
              .utc(comment.date)
              .local()
              .format())}
          {#if role === $session.user.last_role}
            <a href="javascript:;" on:click={() => open()}>
              <i class="material-icons" style="font-size: 16px; float: right;">
                edit
              </i>
            </a>
          {/if}
        </div>
        {#if comment.message !== null}
          <p style="margin-top: 5px">{comment.message}</p>
        {/if}

      </div>
    </div>
  </div>
</article>

<div id={'edit-dialog-' + role} class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2
        class="mdc-dialog__title"
        style="text-align: center"
        id="my-dialog-title">
        {t9n(TS.ORDER_CONF_TIME)}
      </h2>

      <div
        class="mdc-dialog__content"
        id="my-dialog-content"
        style="z-index: 9999">
        <div style="padding-left: 20px; padding-right: 20px;">
          {#if order && has_inited}
            <p>{order.details.confirmed_order_time}</p>
          {/if}

          {#if $session.user.last_role === 'orderer'}
            <h4>{t9n(TS.ORDER_RATE_WORKER)}</h4>
          {:else}
            <h4>{t9n(TS.ORDER_RATE_ORDERER)}</h4>
          {/if}

          <p>{t9n(TS.ORDER_FEEDBACK_TEXT)}</p>
        </div>

        <div style="padding-left: 20px; padding-right: 20px;">
          <h4>{t9n(TS.ORDER_CHOOSE_RAT)}</h4>
        </div>

        {#each complete_ratings as rating, i}
          <a
            href="javascript:;"
            class:ratings={i === 0}
            on:click={() => rating_set_active(i)}>
            <i class="material-icons" class:active-icon={rating.is_active}>
              {get_rating_icon(rating.name)}
            </i>
          </a>
        {/each}

        <div class="textfield-margin">
          <TextField
            bind:value={short_comment}
            label={t9n(TS.ORDER_SHORT_COMMENT)}
            max_chars={20000}
            show_counter={false}
            id="approve-textfield"
            width="410px" />
        </div>
      </div>

      <footer
        class="mdc-dialog__actions"
        style="margin-bottom: 20px;padding-right: 24px;">
        <!--                {#each buttons as button}-->
        <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
        <!--                            tabindex="0"-->
        <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
        <!--                        {button.label}-->
        <!--                    </button>-->
        <!--                {/each}-->

        <button
          on:click={() => close()}
          class="mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.TXT_CANCEL)}
        </button>

        <button
          on:click={async () => { await edit_comment() } }
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.ORDER_SUBMIT)}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  a,
  a:active,
  a:focus {
    outline: none;
  }

  .comment-message {
    background: white;
    border-radius: 5px;
    -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }

  .comment-message span,
  .comment-message img {
    display: flex;
  }

  .comment-message-header {
    height: 30px;
    padding: 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    justify-content: space-between;
  }

  .orderer .comment-message-header {
    background-color: var(--orderer-background-color);
    color: var(--orderer-foreground-color);
  }

  .worker .comment-message-header {
    background-color: var(--worker-background-color);
    color: var(--worker-foreground-color);
  }

  .comment-message-content {
    min-height: 50px;
    padding: 10px;
    font-size: 14px;
    overflow-x: hidden;
    word-break: break-all;
  }

  .comment-date {
    font-size: 12px;
    color: #616161;
  }

  .orderer .comment-icon .material-icons {
    background-color: var(--orderer-background-color);
  }

  .worker .comment-icon .material-icons {
    background-color: var(--worker-background-color);
  }

  .comment-avatar,
  .comment-rate {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .column-comment {
    float: left;
    padding: 5px;
    width: 100%;
  }

  .row {
    width: 48%;
    margin: 5px;
  }

  .rating-block {
    padding: 4px 0;
  }

  .name-text {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    overflow-x: hidden;
    padding: 0 5px;
  }

  /*.comment-rate {*/
  /*    float: right;*/
  /*}*/

  .mdc-dialog .mdc-dialog__surface {
    max-width: 500px;
    width: 500px;
  }

  .mdc-dialog .material-icons {
    font-size: 50pt;
    color: var(--orderer-background-color);
    opacity: 50%;
  }

  .mdc-dialog .material-icons:hover {
    opacity: 70%;
  }

  .mdc-dialog .active-icon {
    opacity: 100%;
    animation: transition_in 0.3s;
  }

  a:link {
    color: #757575;
  }

  .worker a:hover {
    color: var(--orderer-background-color);
  }

  .orderer a:hover {
    color: var(--worker-background-color);
  }

  .ratings {
    margin-left: 90px;
  }

  .btn-close {
    margin-left: 5px;
  }

  .textfield-margin {
    margin-top: 15px;
    margin-left: 20px;
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .row {
      width: 100%;
    }

    .mdc-dialog .mdc-dialog__surface {
      max-width: 320px;
    }

    .ratings {
      margin-left: 5px;
    }

    .textfield-margin {
      margin-top: 10px;
      margin-left: 0;
    }
  }
</style>
